/* global jQuery COMPONENTS Plyr */

COMPONENTS.ComponentVideoCallout = (function ($) {
  function ComponentVideoCallout () {
    this.utility = new COMPONENTS.Utility()
    this.$component = $('[data-ecs-component="component-videocallout"]')
    this.$plyrElements = this.$component.find('[data-ecs-components-control="plyr"]')
  }

  /**
   * Initialise a single Plyr player element.
   *
   * @param {HTMLElement} el  The element with data-ecs-components-control="plyr".
   */
  ComponentVideoCallout.prototype.initPlayer = function (el) {
    var iconUrl = window.ECS_PLYR && window.ECS_PLYR.iconUrl
    var player = new Plyr(el, iconUrl ? { loadSprite: false, iconUrl: iconUrl } : {})
    var autoplay = $(el).data('plyrAutoplay')

    if (autoplay === 'autoplay_yes') {
      player.on('ready', function () {
        player.muted = true
        player.play()
      })
    }
  }

  ComponentVideoCallout.prototype.init = function () {
    var component = this

    if (this.$plyrElements.length < 1) {
      return
    }

    component.$plyrElements.each(function () {
      var el = $(this).get(0)
      var consentCategory = $(this).data('plyrConsentCategory')

      // No consent requirement — init immediately.
      if (!consentCategory) {
        component.initPlayer(el)
        return
      }

      // Consent required. Defer Plyr initialisation (and therefore iframe
      // creation) until the nearest cookie-interstitial ancestor receives
      // data-consent-granted. Using a MutationObserver decouples us from
      // consent event timing — it fires correctly whether ecsCookieCheck
      // (prior consent on page load) resolves before or after components_init.
      var interstitial = el.closest('[data-cookie-interstitial]')
      if (!interstitial) {
        return
      }

      if (interstitial.hasAttribute('data-consent-granted')) {
        // Consent was already recorded before components_init ran.
        component.initPlayer(el)
      } else {
        var obs = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (
              m.attributeName === 'data-consent-granted' &&
              interstitial.hasAttribute('data-consent-granted')
            ) {
              obs.disconnect()
              component.initPlayer(el)
            }
          })
        })
        obs.observe(interstitial, { attributes: true })
      }
    })
  }

  return ComponentVideoCallout
})(jQuery)

document.addEventListener('components_init', function () {
  COMPONENTS.componentVideoCallout = new COMPONENTS.ComponentVideoCallout()
  COMPONENTS.componentVideoCallout.init()
})
